module.exports = __webpack_public_path__ + "assets/discover-fb86f4.svg";